function DailySoldReportChildTableRow({row, monthly_column_keys}: any) {
  return (
    <tr
      className={`${
        row?.['suggested_order_qty'] > 0
          ? `bg-light-success`
          : row?.['suggested_order_qty'] < 0
          ? `bg-light-danger`
          : ``
      }`}
      key={row?.['sku']}
    >
      <td>
        <div></div>
      </td>
      <td>{row?.['sku']}</td>
      <td>{row?.['product_title']}</td>
      <td className='text-center'>{row?.['reserved_quantity'] || '-'}</td>
      <td className='text-center'>{row?.['quantity_available'] || '0'}</td>
      <td className='text-center border-end'>{row?.['quantity_incoming'] || '0'}</td>

      {monthly_column_keys &&
        monthly_column_keys !== undefined &&
        monthly_column_keys.map((column: any) => (
          <td>
            <div className='align-items-center text-center'>{row[column]}</div>
          </td>
        ))}

      <td>
        <div className='text-center'>{row['total_month_quantity']}</div>
      </td>
    </tr>
  )
}

export default DailySoldReportChildTableRow
